// Module
var code = "<div class=\"btn-group\"><select class=\"form-control btn\" ng-model=\"newFilter.user_value\" ng-options=\"user.name as user.name for user in users\"><option disabled=\"disabled\" value=\"\">Value</option></select></div>\n";
// Exports
module.exports = code;